import { BaseIcon } from './BaseIcon';
import { ReactComponent as svg } from './svgIcons/visibility.svg';

export const VisibilityIcon = ({ ...props }) => (
  <BaseIcon svg={svg} {...props} />
);
